import { gql } from '@apollo/client';

export const DUPLICATE_SESSION = gql`
  mutation duplicateSession($id: ID!) {
    session: duplicateSession(id: $id) {
      id
      description
    }
  }
`;
